
import {
    getCannedMessageText, getCannedMessagesKey,
} from '../../utils/cannedmessages'
import {
    styledButton,
    styledKeyword,
    styledLi,
    styledMessage,
    styledUl,
} from './styles/CannedMessagesListView'
import {CannedMessage} from 'components/SendCannedMessages/types'
import {CannedMessagesListViewProps} from './types'
import React from 'react'

import {styled} from 'stitches/config'

const StyledUl = styled('ul', styledUl)

const StyledLi = styled('li', styledLi)

const StyledButton = styled('button', styledButton)

const StyledKeyword = styled('small', styledKeyword)

const StyledMessage = styled('div', styledMessage)

const CannedMessagesList = (props: CannedMessagesListViewProps): React.ReactElement => {
    const {
        cannedMessages,
        supportedCannedMessagesLanguages,
        onSelect,
    } = props

    const defaultState: CannedMessage[] = []

    const [sortedCannedMessages, setSortedCannedMessages] = React.useState(defaultState)

    // ignore other languages and only show values for 'message'
    const cannedMessageKey = getCannedMessagesKey(supportedCannedMessagesLanguages, 'message')

    React.useEffect(() => {
        // Alphabetic order based on keywords
        const sorted = [...cannedMessages].sort((a, b) => {
            const [A] = a.keywords
            const [B] = b.keywords
            return A > B ? 1 : 0
        })
        setSortedCannedMessages(sorted)
    }, [cannedMessages?.length])

    return (
        <StyledUl>
            {sortedCannedMessages
                .filter((m) => {
                    const msgText = getCannedMessageText(m, cannedMessageKey)
                    return msgText && msgText.length > 0
                })
                .map((m) => (
                    <StyledLi key={m.keywords[0]}>
                        <StyledButton
                            onClick={(): void => onSelect({
                                ...m,
                                withLegacyKey: true, // for legacy support
                            })}
                            type='button'
                        >
                            <StyledKeyword>{m.keywords[0]}</StyledKeyword>
                            <StyledMessage>{getCannedMessageText(m, cannedMessageKey)}</StyledMessage>
                        </StyledButton>
                    </StyledLi>
                ))}
        </StyledUl>
    )
}

export default CannedMessagesList
